<template>
  <div>
  <seccion-slider/>
  <seccion-cob/>
  <seccion-planes/>
  <preguntas-respuestas></preguntas-respuestas>
  <nosotros></nosotros>
  </div>
</template>

<script>
  import SeccionSlider from '../components/Layout/Slider'
  import SeccionCob from '../components/Layout/Coberturas'
  import PreguntasRespuestas from '../components/Layout/FaqSection'
  import SeccionPlanes from '../components/Layout/Planes'
  import Nosotros from '../components/Layout/Nosotros'
  export default {
    components: {
      SeccionSlider,
      SeccionCob,
      PreguntasRespuestas,
      SeccionPlanes,
      Nosotros
    },
  }
</script>
